module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow@3x-c2c4dbd4dd2a019a93d5b223a02f8433.png";